import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    影视分类: [
      { name: '电影', path: '/category/movie' },
      { name: '电视剧', path: '/category/tv' },
      { name: '动漫', path: '/category/anime' },
      { name: '综艺', path: '/category/variety' },
      { name: '纪录片', path: '/category/documentary' },
    ],
    热门推荐: [
      { name: '流浪地球3', path: '/category/movie' },
      { name: '庆余年第二季', path: '/category/tv' },
      { name: '哪吒之魔童闹海', path: '/category/anime' },
      { name: '封神第二部', path: '/category/movie' },
      { name: '繁花', path: '/category/tv' },
    ],
    关于我们: [
      { name: '品牌介绍', path: '/about' },
      { name: '联系方式', path: '/about' },
      { name: '用户协议', path: '/about' },
      { name: '隐私政策', path: '/about' },
    ],
  };

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="font-heading text-xl font-bold text-white whitespace-nowrap">
                成全影视
              </Link>
              <p className="mt-3 text-sm text-background-400 leading-relaxed">
                高清免费影视平台，提供电影、电视剧、动漫、综艺等海量资源，免费在线观看，流畅追剧体验。
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer" aria-label="B站" rel="nofollow">
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
              </div>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="font-heading text-sm font-semibold text-white mb-4">
                  {title}
                </h4>
                <ul className="space-y-2.5">
                  {links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-400 hover:text-white transition-colors whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-6 border-t border-background-800">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-xs text-background-500">
                &copy; 2026 成全影视 ChengQuan Movies. 本站所有资源均来自互联网，仅供学习交流使用。
              </p>
              <p className="text-xs text-background-500">
                ICP备案号：京ICP备2024000000号-1
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}